"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var tokens_1 = require("../../tokens");
var Paragraph = function (props) { return (React.createElement(Paragraph.Element, __assign({}, automation_attribute_1.default('paragraph'), props), props.children)); };
Paragraph.Element = styled_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  margin: 1em 0;\n  color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n"], ["\n  ", ";\n  margin: 1em 0;\n  color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n"])), container_styles_1.default, tokens_1.colors.text.default, tokens_1.fonts.weight.normal);
var StyledParagraph = Paragraph.Element;
exports.StyledParagraph = StyledParagraph;
exports.default = Paragraph;
var templateObject_1;
//# sourceMappingURL=paragraph.js.map